import axios from "@/config/axiosConfig";
import { REGISTER_BROKER_NOTIFICATIONS_REQUEST, GET_REGISTER_BROKER_NOTIFICATIONS, REGISTER_BROKER_NOTIFICATIONS_REQUEST_FAILURE, GET_REGISTER_BROKER_NOTIFICATIONS_COUNT } from "../types";

export const getRegisterBrokerNotifications = (status) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: REGISTER_BROKER_NOTIFICATIONS_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, status };

      return axios.get("/broker-login/get-broker-requests", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_REGISTER_BROKER_NOTIFICATIONS, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: REGISTER_BROKER_NOTIFICATIONS_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: REGISTER_BROKER_NOTIFICATIONS_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getRegisterBrokerNotificationsCount = () => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };

      return axios.get("/broker-login/get-broker-requests-count", { params }).then((response) => {
        dispatch({ type: GET_REGISTER_BROKER_NOTIFICATIONS_COUNT, payload: response.data?.count || 0 });
        return response.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_REGISTER_BROKER_NOTIFICATIONS_COUNT, payload: 0 });
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const rejectBrokerRequest = (id) => {
    return async (dispatch, getState) => {
        try {
          console.log('<<id--', id);
            return axios.put(`/broker-login/update-broker-request`,
              {},
              { params: { id, status: 'REJECT' }
            }).then( async (response) => {
                dispatch(getRegisterBrokerNotifications());
                dispatch(getRegisterBrokerNotificationsCount());
                return response;
            }).catch((error) => {
                console.error(error);
                console.log('<<error--', error.messege, error.response?.data?.error);
                throw new Error(error.response?.data?.error || error.messege);
            });
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
};